<div [formGroup]="serviceEditForm">
  <div class="row mb-3">
    <div class="col-12">
      <label class="form-label" for="name">{{ 'i18n.shared.fields.name' | translate }}</label>
      <input id="name" class="form-control e-textbox" formControlName="name" />
      @if (serviceEditForm.controls.name.invalid && serviceEditForm.controls.name.touched) {
        <div class="text-danger small mt-1">{{ 'i18n.validation.required' | translate }}</div>
      }
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label class="form-label" for="description">{{ 'i18n.domain.services.fields.description' | translate }}</label>
      <textarea id="description" class="form-control e-textbox" formControlName="description" rows="3"></textarea>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label class="form-label" for="baseStatus">{{ 'i18n.domain.services.fields.baseStatus' | translate }}</label>
      <ejs-dropdownlist id="baseStatus"
                        formControlName="baseStatus"
                        [dataSource]="statusOptions"
                        [fields]="dropdownFields">
      </ejs-dropdownlist>
    </div>
  </div>
</div>
